<template>
  <div class="home">
    <div class="main_container">
      <div class="today">{{today.today_dateStr}}<span v-if="this.city"> @{{this.city}} {{Math.round(this.temp)}}度 {{this.condition}} 気圧{{this.pressure}}hPa </span> </div>
      <p style="text-align:right"><span v-if="isAutoSave" style="font-size:.8em; color:#82C91E;">下書き保存: {{this.isAutoSaveTime}} <i class="fas fa-check"></i></span> 文字数 {{message.length}}</p>
      <div v-if="status">
        <textarea v-model="message" type="textarea" rows="18"></textarea>
      </div>
      <div v-if="!status">
        <p>THANK YOU!</p>
        <p>この画面は一番最初のログインか、お試し期間の終了か、カードの決済処理がエラーの時に表示されます。</p>
        <p>一番最初のログインのお客様はユーザ登録中です。しばらく待ってから更新してください。</p>
        <p>お試し期間終了のお客様はカード登録をしてください。</p>
        <p><router-link to="/stripe">カード登録をする</router-link></p>
        <p>カード情報の登録済みでエラーのお客様はカードをご確認ください。
        <p>もし不明な点があれば、お問い合わせください。</p>
      </div>
      <b-field label="【自己気分評価】">
        <b-select v-model="feeling" placeholder="自分の気分">
          <option value="happy">😆喜</option>
          <option value="angry">😡怒</option>
          <option value="sad">😢哀</option>
          <option value="enjoy">😁楽</option>
          <option value="bad">😩困</option>
          <option value="shock">😱ショック</option>
        </b-select>
      </b-field>
      <section>
        <b-field label="【自己感情スコア】" style="max-width:240px;">
           {{feeling_score}}点<b-slider v-model="feeling_score" :tooltip-type="sliderType"></b-slider>
        </b-field>
      </section>
      <div v-if="this.status" class="submit_button"><b-button type="is-info" style="font-weight:bold;" @click="submitCheck">登録する</b-button></div>
      <hr/>
      <p class="title is-6">【お天気情報】</p>
      <b-field label="地域">
        <b-select v-model="city" placeholder="お住いの地域">
          <option value="">登録しない</option>
          <option value="Sapporo">札幌</option>
          <option value="Aomori">青森県</option>
          <option value="Morioka">盛岡</option>
          <option value="Miyagi">宮城県</option>
          <option value="Akita">秋田県</option>
          <option value="Yamagata">山形県</option>
          <option value="Fukushima">福島県</option>
          <option value="Ibaraki">茨城県</option>
          <option value="Tochigi">栃木県</option>
          <option value="Maebashi">前橋</option>
          <option value="Saitama">埼玉県</option>
          <option value="Chiba">千葉県</option>
          <option value="Tokyo">東京都</option>
          <option value="Kanagawa">神奈川県</option>
          <option value="Niigata">新潟県</option>
          <option value="Toyama">富山県</option>
          <option value="Ishikawa">石川県</option>
          <option value="Fukui">福井県</option>
          <option value="Yamanashi">山梨県</option>
          <option value="Nagano">長野県</option>
          <option value="Ogaki">大垣（岐阜）</option>
          <option value="Shizuoka">静岡県</option>
          <option value="Nagoya">名古屋</option>
          <option value="Mie">三重県</option>
          <option value="Otsu">大津</option>
          <option value="Kyoto">京都府</option>
          <option value="Osaka">大阪府</option>
          <option value="Kobe">神戸</option>
          <option value="Nara">奈良県</option>
          <option value="Wakayama">和歌山県</option>
          <option value="Tottori">鳥取県</option>
          <option value="Matsue">松江</option>
          <option value="Okayama">岡山県</option>
          <option value="Hiroshima">広島県</option>
          <option value="Yamaguchi">山口県</option>
          <option value="Tokushima">徳島県</option>
          <option value="Takamatsu">高松</option>
          <option value="Matsuyama">松山</option>
          <option value="Tosa">土佐</option>
          <option value="Fukuoka">福岡県</option>
          <option value="Saga">佐賀県</option>
          <option value="Nagasaki">長崎県</option>
          <option value="Kumamoto">熊本県</option>
          <option value="Beppu">別府</option>
          <option value="Miyazaki">宮崎県</option>
          <option value="Kagoshima">鹿児島県</option>
          <option value="Itoman">糸満市（沖縄県）</option>
        </b-select>
      </b-field>
      <span v-if="this.condition">
        <b-field label="天候の変更(天候が違っていた場合)">
          <b-select v-model="condition" placeholder="天候を変更">
            <option value="Clear">晴れ</option>
            <option value="Clouds">曇り</option>
            <option value="Rain">雨</option>
            <option value="Snow">雪</option>
          </b-select>
        </b-field>
      </span>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import axios from 'axios'
import kuromoji from "kuromoji"
import emotion from '@/assets/emotion.json'
import store from '@/store'
export default {
  name: 'home',
  data() {
    return{
      message: '',
      savedText: '',
      isChanged: false,
      isMetaData: false,
      isSubmit: false,
      isAutoSave: false,
      isAutoSaveTime: '',
      saved_length: 0,
      length: 0,
      status: null,
      feeling: 'happy',
      feeling_score: 60,
      //weather Info
      city: null, 
      temp: null,
      pressure: null, 
      condition:null,
      //kuromoji
      outputToken: [],
      builder: kuromoji.builder({ dicPath: "/dict" }),
      emotionData: [],
      emotion_text: "",
    }
  },
  computed:{
    today(){
      return this.$store.getters.today_info;
    },
    user(){
      return this.$store.getters.user;
    },
    sliderType(){
      if (this.feeling_score > 25 && this.feeling_score < 75){
        return "is-warning";
      } else if (this.feeling_score >= 75){
        return "is-success";
      }
        return "is-danger";
    }
  },
  mounted(){
    const title = "ホーム｜エモーションダイアリー"
    const description = "ホーム画面"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)

    const BASEURL = 'https://api.openweathermap.org/data/2.5/weather?q='
    const CITY = this.city
    const AFTERBASEURL = ',jp&units=metric&appid=c10a411951ca64b73aec82f13574ab74'
    axios.get(BASEURL + CITY + AFTERBASEURL)
    .then(function(response){
      this.city = response.data.name
      this.temp = Math.round(response.data.main.temp)
      this.pressure = response.data.main.pressure
      var weather_type = response.data.weather[0].main
        switch(weather_type) {
          case 'Clear':
            this.condition = '晴れ'
            break;
          case 'Clouds':
            this.condition = 'くもり'
            break;
          case 'Rain':
            this.condition = '雨'
            break;
          case 'Snow':
            this.condition = '雪'
            break;
        default:
      }
    }.bind(this))
    .catch(function(error){
      console.log(error)
    });
    this.$nextTick(function () {
      store.commit('end')
    })
  },
  watch:{
    message(){
      if(this.savedText != this.message &&  !this.isChanged){
        this.savedText = this.message
        this.isChanged = true
        setTimeout(this.autoSave, 60000);
      }
    },
    city(){
      const BASEURL = 'https://api.openweathermap.org/data/2.5/weather?q='
      const CITY = this.city
      const AFTERBASEURL = ',jp&units=metric&appid=c10a411951ca64b73aec82f13574ab74'
      axios.get(BASEURL + CITY + AFTERBASEURL)
      .then(function(response){
        this.city = response.data.name
        this.temp = Math.round(response.data.main.temp)
        this.pressure = response.data.main.pressure
        var weather_type = response.data.weather[0].main
        switch(weather_type) {
          case 'Clear':
            this.condition = '晴れ'
            break;
          case 'Clouds':
            this.condition = '曇り'
            break;
          case 'Rain':
            this.condition = '雨'
            break;
          case 'Snow':
            this.condition = '雪'
            break;
        default:
        }
      }.bind(this))
      .catch(function(error){
        console.log(error)
      })
    }
  },
  created(){
    store.commit('start')
    firebase.firestore().collection('user').doc(this.user.uid).get().then((doc) => {
      var data = doc.data()
      if(data.status){
        this.status = data.status
      }
      console.log(this.status)
      this.city = data.city ? data.city : null;
    });

    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(this.today.today_year + '_' + this.today.today_month).doc(String(this.today.today_day)).get().then((doc) => {
      var data = doc.data()
      this.message = data.message
      this.savedText = data.message
      this.isSubmit = data.isSubmit ? data.isSubmit : false
      this.emotionData = data.emotionData ? data.emotionData : []
      this.feeling = data.feeling ? data.feeling : 'happy'
      this.feeling_score = data.feeling_score ? data.feeling_score : 60 
      this.saved_length = data.length 
      this.length =  data.length
    });
  },
  methods: {
    submitCheck(){
      this.$buefy.dialog.confirm({
      message: '登録しますか？（文章の書き直しはできますがデータ分析は一日一度だけです）',
      onConfirm: () =>  
        this.prepareConv()
      })
    },
    submit(){
      if(this.condition){
        switch(this.condition) {
          case 'Clear':
            this.condition = '晴れ'
            break;
          case 'Clouds':
            this.condition = 'くもり'
            break;
          case 'Rain':
            this.condition = '雨'
            break;
          case 'Snow':
            this.condition = '雪'
            break;
        default:
        }
      }
      //firestoreの保存設定
      firebase.firestore().collection('diary_text').doc(this.user.uid).collection(this.today.today_year + '_' + this.today.today_month).doc(String(this.today.today_day)).set({
        day: this.today.today_day,
        length: this.message.length,
        message: this.message,
        isSubmit: true,
        feeling: this.feeling,
        feeling_score: this.feeling_score,
        writingTime: new Date(),
        wetherInfo:{
          city: this.city,
          temp: Math.round(this.temp),
          condition: this.condition,
          pressure: this.pressure
        }
      },{ merge: true }).then(()=>{
        firebase.firestore().collection('user').doc(this.user.uid).set({
          city: this.city
        },{ merge: true })
      }).then(()=>{
        store.commit('end')
        this.isSubmit = true
        this.$buefy.toast.open('送信しました')
        this.$router.push({ name: 'archive', params:{ id_year: this.today.today_year, id_month: this.today.today_month, id_day:this.today.today_day }})
      });

      //storageの保存設定
      var year_name = this.today.today_year;
      var month_name = this.today.today_month;
      var day_name = this.today.today_day;
      if(!this.isSubmit){
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(`${this.user.uid}/${year_name}_${month_name}/${day_name}`);

        fileRef.putString(this.message).then(function(snapshot) {
          console.log('Uploaded a raw string!');
          console.log(snapshot)
        });
      }else{
        console.log("already exist")
      }

    },
    autoSave(){
      this.emotion_text = this.message.slice(this.saved_length)
      var time = new Date()
      var hour = time.getHours();
      var minute = time.getMinutes();
      this.isAutoSaveTime = hour + '時' + minute + '分'

      this.isChanged = false
      this.isAutoSave = true

      //文字数の差額を取得するための処理
      this.length = this.message.length - this.saved_length
      this.saved_length = this.message.length

      this.autoConv()

      firebase.firestore().collection('diary_text').doc(this.user.uid).collection(this.today.today_year + '_' + this.today.today_month).doc(String(this.today.today_day)).set({
        day: this.today.today_day,
        length: this.message.length,
        message: this.message,
        emotionData: this.emotionData,
        writing_info: firebase.firestore.FieldValue.arrayUnion({
          time: time,
          total_length: this.message.length,
          length: this.length
        })
      },{ merge: true });
    },
    autoConv: async function() {
      var vm = this
      this.builder.build(await function(err, tokenizer){
        if(err){
          throw err
        } else {
          var token = tokenizer.tokenize(vm.emotion_text)
          vm.outputToken = token
          for(var key in token){ 
                const target = emotion.emotion.find((x) => {
                    return (x.Katakana == token[key].reading);
                      });
                if(target){
                  vm.emotionData.push(target)
                }
            }
          }
      });
      this.convMessage = this.message
    },
    prepareConv(){
      this.emotion_text = this.message.slice(this.saved_length)
      store.commit('start')
      this.conv()
    },
    conv: async function() {
      var vm = this
      this.builder.build(await function(err, tokenizer){
        if(err){
          throw err
        } else {
          var token = tokenizer.tokenize(vm.emotion_text)
          vm.outputToken = token
          for(var key in token){ 
                const target = emotion.emotion.find((x) => {
                    return (x.Katakana == token[key].reading);
                      });
                if(target){
                  vm.emotionData.push(target)
                }
            }
          vm.submit()
          }
      });
    }
  }

}
</script>

<style scoped>
.home{
  max-width: 800px;
  margin:auto;
}
.today{
  text-align: left;
  font-weight: bold;
  padding-bottom: 4px;
}
nav{
  max-width: 800px;
  margin:auto;
}
.message_length{
  font-weight: bold;
  padding-top: 4px;
  text-align: right;
}
.submit_button{
  text-align: left;
  padding-top: 24px;
}
textarea {
 outline: 0;
 width: 100%;
 font-size: 16px;
 padding: 10px;
}
</style>

